import { defineMessages } from 'react-intl';

export default defineMessages({
    title: {
        id: '_.modal.help.iwocaPay.title',
        defaultMessage: 'Need help?'
    },
    phoneCaption: {
        id: '_.modal.help.iwocaPay.phone_caption',
        defaultMessage: 'Call us at'
    },
    displayPhoneNumber: {
        id: '_.modal.help.iwocaPay.display_number',
        defaultMessage: '0203 778 0549'
    },
    callPhoneNumber: {
        id: '_.modal.help.iwocaPay.call_number',
        defaultMessage: '+44-0203-778-0549'
    },
    availabilityMessageLineOne: {
        id: '_.modal.help.iwocaPay.availability_message_line_one',
        defaultMessage: 'Monday to Friday'
    },
    availabilityMessageLineTwo: {
        id: '_.modal.help.iwocaPay.availability_message_line_two',
        defaultMessage: '9am - 6pm'
    },
    emailCaption: {
        id: '_.modal.help.iwocaPay.email_caption',
        defaultMessage: 'Email at'
    },
    email: {
        id: '_.modal.help.iwocaPay.email',
        defaultMessage: 'pay@iwoca.co.uk'
    },
    chatCaption: {
        id: '_.modal.help.iwocaPay.chat_caption',
        defaultMessage: 'You can also'
    },
    chat: {
        id: '_.modal.help.iwocaPay.chat',
        defaultMessage: 'Chat to us!'
    },
    faqCaption: {
        id: '_.modal.help.iwocaPay.faq_caption',
        defaultMessage: 'Find answers to common questions in our'
    },
    faq: {
        id: '_.modal.help.iwocaPay.faq',
        defaultMessage: 'FAQ'
    }
});
